import React from 'react';
import '../styles/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <h1>AVISO DE PRIVACIDAD</h1>
        <h2>GIGANTE GRUPO INMOBILIARIO, S.A. DE C.V.</h2>
        
        <p>En cumplimiento a lo previsto en la Ley Federal de Protección de Datos Personales en
        Posesión de los Particulares (en lo sucesivo la "Ley"), su Reglamento (en lo sucesivo el
        "Reglamento") y los Lineamientos del Aviso de Privacidad publicados en el Diario Oficial
        de la Federación el 17 de enero de 2013, nos permitimos informarle lo siguiente:</p>
        
        <h3>1.- RESPONSABLE DE LOS DATOS PERSONALES</h3>
        <p>Gigante Grupo Inmobiliario, S.A. de C.V., (en lo sucesivo la "Sociedad"), señalando para
        efectos del presente Aviso de Privacidad el domicilio ubicado en Av. Ejército Nacional
        Mexicano No. 769, Torre B, Piso 15, Colonia Granada, C.P. 11520, Miguel Hidalgo, Ciudad
        de México, México, será el responsable de los datos personales que le sean proporcionados
        respecto de las personas físicas a quienes correspondan los mismos (en lo sucesivo
        el "Titular" o los "Titulares").</p>
        
        <h3>2.- DATOS PERSONALES QUE SE SOLICITAN DEL TITULAR</h3>
        <p>Para las finalidades señaladas en el presente Aviso de Privacidad, la Sociedad recabará
        los siguientes datos personales del Titular: nombre, domicilio, fecha de nacimiento, género,
        correo electrónico, la imagen del Titular captada a través de las cámaras de videovigilancia
        y seguridad ubicadas en las instalaciones de la Sociedad, información relacionada con el
        dispositivo que el Titular utilice para hacer uso de la red wifi en las instalaciones de la
        Sociedad, así como su historial de compra y las preferencias e intereses del Titular
        relacionados con los servicios que ofrecemos (en lo sucesivo, los "Datos Personales").</p>
        <p>Los Datos Personales de los Titulares se podrán recabar de las siguientes formas: (i)
        cuando el Titular los proporcione, personal o directamente, y (ii) cuando la Sociedad los
        obtenga de forma indirecta, por medio de fuentes de acceso público, incluyendo redes
        sociales, o transferencias.</p>
        <p>Asimismo, se informa a los Titulares que en caso de utilizar la página de internet de la
        Sociedad (https://ggi.com.mx), dicha página utiliza "cookies", mediante las cuales se
        obtienen los siguientes datos: dirección IP, vínculos que sigue, sitios de visita, duración de
        tiempo de interacción en la página y tipo de navegador. Este tipo de información es
        generalizada y sólo se utiliza para obtener información estadística del comportamiento de
        navegación en la página de internet con la finalidad de optimizar el diseño y funcionamiento
        del sistema en los dispositivos de los usuarios.</p>
        
        <h3>3.- FINALIDADES PARA LAS QUE SE RECABAN LOS DATOS PERSONALES</h3>
        <h4>3.1. Finalidades Primarias.</h4>
        <p>Los Datos Personales del Titular son tratados por la Sociedad
        para cumplir con las siguientes finalidades que son necesarias para cumplir las obligaciones
        derivadas de la relación jurídica que la Sociedad tenga con el Titular: (i) identificar al Titular;
        (ii) el arrendamiento o la venta de locales comerciales y/u oficinas, (iii) la prestación de
        servicios ofrecidos por la Sociedad y/o página de internet y/o aplicación móvil ("app") y/o
        "call center" de la Sociedad; (iv) entregar al Titular los servicios que este último adquiera
        y/o contrate de la Sociedad (incluyendo entregas a domicilio); (v) emitir la factura
        correspondiente respecto de los servicios adquiridos por el Titular, cuando este último así
        lo requiera; (vi) permitir al Titular conectarse a la red wifi en las instalaciones de la Sociedad;
        y (vii) atender oportunamente las quejas, reclamaciones, solicitudes y/o sugerencias del
        Titular, así como, realizar el seguimiento respecto de los servicios que haya adquirido de la
        Sociedad.</p>
        <p>Por lo que se refiere a la imagen de los Titulares captada a través de las cámaras de
        videovigilancia y seguridad ubicadas en las instalaciones de la Sociedad, ésta se utilizará
        con la finalidad de mantener la seguridad de clientes, colaboradores, proveedores y demás
        personas que se encuentren en las instalaciones de la Sociedad, así como para proteger
        el patrimonio de ésta última.</p>
        
        <h4>3.2. Finalidades Secundarias.</h4>
        <p>Asimismo, dentro del uso que la Sociedad dará a los Datos
        Personales del Titular está: (i) informar al Titular de promociones, locales comerciales u
        oficinas disponibles para venta o renta, compras con beneficios y/o descuentos, así como
        de aperturas de nuevas ubicaciones de la Sociedad; (ii) proporcionar al Titular publicidad
        respecto de los bienes y/o servicios ofrecidos por la Sociedad y/o por sus Afiliadas (según
        dicho término se define más adelante); (iii) invitar al Titular a participar en eventos,
        concursos, sorteos y actividades, y, en su caso, realizar la entrega del premio que
        corresponda, de conformidad con los términos y condiciones aplicables; (iv) contactarlo a
        través de distintos medios de comunicación físicos o electrónicos, y a través de redes
        sociales, y, en su caso, atender sus solicitudes a través de los mismos; (v) identificar los
        hábitos de consumo del Titular y realizar actividades de prospección comercial de carácter
        personalizado de acuerdo con sus intereses y preferencias de consumo, y (vi) desarrollar
        y mejorar nuestros productos y servicios mediante la evaluación de su calidad, incluyendo
        la realización de encuestas, así como la recopilación de información para efecto de las
        finalidades del presente numeral (las "Finalidades Secundarias").</p>
        
        <h3>4.- TEMPORALIDAD DEL TRATAMIENTO DE DATOS PERSONALES</h3>
        <p>La temporalidad del manejo de los Datos Personales de los Titulares, no excederá el plazo
        de conservación necesario para (i) el cumplimiento de las finalidades establecidas en el
        presente Aviso de Privacidad, y (ii) el cumplimiento de las obligaciones exigidas por la
        legislación vigente y las autoridades competentes, sin embargo, en relación con los Datos
        Personales correspondientes a la imagen de los Titulares que es captada por las cámaras
        de videovigilancia de las instalaciones de la Sociedad, dicha información es conservada
        por la Sociedad únicamente por un plazo de 15 días naturales posteriores a la fecha en la
        que se obtiene y una vez transcurrido dicho plazo es suprimida.</p>
        
        <h3>5.- TRANSFERENCIAS DE DATOS PERSONALES</h3>
        <h4>5.1. Transferencias de Datos Personales no sujetas al consentimiento del Titular.</h4>
        <p>La Sociedad podrá transferir los Datos Personales señalados en la sección 2 del Aviso de
        Privacidad a sus empresas filiales, subsidiarias, controladora, afiliadas y/o que pertenezcan al mismo grupo de control de la Sociedad.</p>
        
        <h4>5.2. Transferencias de Datos Personales sujetas al consentimiento del Titular.</h4>
        <p>En caso de obtener el consentimiento del Titular, la Sociedad podrá transferir los Datos Personales a terceros para los fines descritos en el aviso completo.</p>
        
        <h3>6.- DERECHOS DE ACCESO, RECTIFICACIÓN, CANCELACIÓN Y OPOSICIÓN</h3>
        <p>Los Titulares tendrán derecho a solicitar el acceso, rectificación y/o cancelación de sus
        Datos Personales, así como a oponerse al tratamiento de los mismos mediante el envío de un escrito libre a la siguiente cuenta de correo
        electrónico: datospersonalesggi@gigante.com.mx, el cual será atendido por el
        Departamento de Datos Personales de la Sociedad.</p>
        
        <h3>7.- MODIFICACIONES AL AVISO DE PRIVACIDAD</h3>
        <p>La Sociedad se reserva el derecho de realizar cualquier cambio o actualización al presente
        Aviso de Privacidad, incluyendo para adaptarlo a novedades legislativas o jurisprudenciales.</p>
        
        <p className="last-update">Fecha de última actualización, abril 2025</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
